import * as React from 'react';
const SvgSanity = (props) => (
  <svg viewBox="0 0 121 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M90.286 8.496v15.132H85.34V6.127l4.947 2.37Z" fill="#F37368" />
    <path
      d="M20.27 20.818 23.98 24l15.632-8.023-1.615-3.825-17.727 8.666Zm65.069-9.749 12.574-6.431-2.13-3.622-10.444 5.11v4.943Z"
      fill="#F7A199"
    />
    <path
      d="M49.953 7.312v16.316h-4.741V.372l4.74 6.94ZM20.27 20.818 23.98 24l7.146-17.602L28.824.372 20.27 20.818Z"
      fill="#F37368"
    />
    <path
      d="M28.824.372h4.879l9.035 23.256h-5.016L28.824.372Zm21.85 0 10.41 15.876v7.38L45.212.372h5.462Zm19.342 0h4.913v23.256h-4.913V.372Zm7.765 4.266V.372h17.624l2.508 4.266H77.781Z"
      fill="#F04939"
    />
    <path d="M112.445 14.793v8.835h-4.878v-8.835" fill="#F7A199" />
    <path d="m115.812.372-8.245 14.42h4.878L121 .373h-5.188Z" fill="#F04939" />
    <path d="M107.567 14.793 99.047.373h5.359l5.738 9.884-2.577 4.536Z" fill="#F37368" />
    <path
      d="M1.958 3.08c0 3.216 2.027 5.146 6.081 6.161l4.295.982c3.847.88 6.184 3.046 6.184 6.567.034 1.523-.481 3.012-1.409 4.231 0-3.52-1.855-5.416-6.287-6.567l-4.226-.948C3.195 12.762.584 10.968.584 7.142c0-1.455.481-2.91 1.374-4.062Z"
      fill="#F04939"
    />
    <path
      d="M61.084.372h4.741v23.256h-4.74L61.083.372ZM14.464 15.91c1.82 1.15 2.645 2.776 2.645 5.111C15.563 22.951 12.918 24 9.791 24c-5.256 0-9-2.573-9.791-7.007h5.05c.653 2.031 2.37 2.979 4.707 2.979 2.783.034 4.672-1.456 4.707-4.062Zm-9.86-8.057a5.341 5.341 0 0 1-2.646-4.806C3.436 1.15 5.978 0 9.07 0c5.394 0 8.486 2.81 9.276 6.736h-4.879c-.55-1.557-1.89-2.775-4.328-2.775-2.646.033-4.432 1.523-4.535 3.892Z"
      fill="#F37368"
    />
  </svg>
);
export default SvgSanity;
